export function returnPrintTemplate(obj) {
  return (`<div style='margin-top:10px;'>
    <!-- <img src='${obj.imgUrl || ''}' style='height:50px;'/> --!>
    <div style="height: 472px;border-left: 1px solid #000;border-right: 1px solid #000;border-top: 1px solid #000;
    font-size: 12px !important;overflow: hidden;box-sizing:border-box;">
      <div style="width: 100%;float: left;height: 100%;box-sizing:border-box;text-align:center;">
        <div style='height:73px;padding:0 10px;font-size:16px;border-bottom:1px solid #000;
        display: flex;justify-content: center;align-items: center;font-weight:800;'>
        ${obj.hua || '苏州供电公司'}<br/>物资卡片
        </div>
        <div style='overflow:hidden;border-bottom:1px solid #000;height:50px;
        display: flex;justify-content: center;align-items: center;'>
          <p style='width:20%;border-right:1px solid #000;margin:0;padding:0;height:100%;line-height:50px;'>
          <span style='text-align:center;font-weight:800;'>物料编码</span>
          </p>
          <p style='width:80%;margin:0;padding:0;font-weight:bold;'>
          <span style='text-align:left;font-size: 10px !important;'>${obj.wlbm || ''}</span>
          </p>
        </div>

        <div style='overflow:hidden;border-bottom:1px solid #000;height:50px;
        display: flex;justify-content: center;align-items: center;'>
          <p style='width:20%;border-right:1px solid #000;margin:0;padding:0;height:100%;line-height:50px;'>
          <span style='text-align:center;font-weight:800;'>批次号</span>
          </p>
          <p style='width:80%;margin:0;padding:0;font-weight:1000;'>
          <span style='text-align:left;font-size: 16px !important;'>${obj.pc || ''}</span>
          </p>
        </div>

        <div style='overflow:hidden;border-bottom:1px solid #000;height:70px;
        display: flex;justify-content: center;align-items: center;'>
          <p style='width:20%;border-right:1px solid #000;margin:0;padding:0;height:100%;line-height:70px;'>
          <span style='text-align:center;font-weight:800;'>物料描述</span>
          </p>
          <p style='width:80%;margin:0;padding:0;font-weight:bold;'>
          <span style='text-align:left;font-size: 10px !important;'>${obj.wlms || ''}</span>
          </p>
        </div>
        <div style='overflow:hidden;border-bottom:1px solid #000;height:50px;
        display: flex;justify-content: center;align-items: center;'>
          <p style='width:20%;border-right:1px solid #000;margin:0;padding:0;height:100%;line-height:50px;'>
          <span style='text-align:center;font-weight:800;'>计量单位</span>
          </p>
          <p style='width:80%;margin:0;padding:0;font-weight:bold;'>
          <span style='text-align:left;font-size: 10px !important;'>${obj.dddw || ''}</span>
          </p>
        </div>
        <div style='overflow:hidden;border-bottom:1px solid #000;height:50px;
        display: flex;justify-content: center;align-items: center;'>
          <p style='width:20%;border-right:1px solid #000;margin:0;padding:0;height:100%;line-height:50px;'>
          <span style='text-align:center;font-weight:800;'>物资数量</span>
          </p>
          <p style='width:80%;margin:0;padding:0;font-weight:1000;'>
          <span style='text-align:left;font-size: 16px !important;'>${obj.num || 0}</span>
          </p>
        </div>
        <div style='overflow:hidden;border-bottom:1px solid #000;height:50px;
        display: flex;justify-content: center;align-items: center;'>
          <p style='width:20%;border-right:1px solid #000;margin:0;padding:0;height:100%;line-height:50px;'>
          <span style='text-align:center;font-weight:800;'>库位</span>
          </p>
          <p style='width:80%;margin:0;padding:0;font-weight:1000;'>
          <span style='text-align:left;font-size: 12px !important;'>${obj.storageLocation || ''}</span>
          </p>
        </div>
        <div style='overflow:hidden;border-bottom:1px solid #000;height:70px;
        display: flex;justify-content: center;align-items: center;'>
          <p style='width:20%;border-right:1px solid #000;margin:0;padding:0;height:100%;line-height:70px;'>
          <span style='text-align:center;font-weight:800;'>备注</span>
          </p>
          <p style='width:80%;margin:0;padding:0;font-weight:1000;'>
          <span style='text-align:left;font-size: 12px !important;'>${obj.gysmc || ''}</span>
          </p>
        </div>
      </div>
    </div>
    <!-- <p style='text-align:center;font-size:12px;height:22px;line-height:22px;margin:0;'>${obj.bottomCode || ''}</p> --!>

    <!-- <div style="height: 97px;border: 1px solid #000;border-top:none;border-bottom:none;fontSize: 12px !important;overflow: hidden;box-sizing:border-box;display: flex;justify-content: center;">
      <img src='${obj.qrCode || ''}' style='height:87px;margin:0;padding:0;'/>
    </div>
    <div style="height: 50px;border: 1px solid #000;font-size: 12px !important;padding:10px 0 0 5px;box-sizing:border-box;display: flex;justify-content: center;align-items: center;">
      <img src='${obj.barCode || ''}' style='height:32px;'/>
    </div> --!>
  </div>
  <p style="page-break-after:always;padding:0;margin:0;"></p>
  <style>
  @media print {
    @page {
      margin: 0;
    }
  }
  </style>`);
}

export function printFn(str,handleFn) {
  const newWindow = window.open("");
  const div = document.createElement("div");
  div.innerHTML = str;
  newWindow.document.write(div.outerHTML);
  newWindow.document.close(); // 在IE浏览器中使用必须添加这一句
  newWindow.focus(); // 在IE浏览器中使用必须添加这一句
  setTimeout(() => {
    newWindow.print(); // 打印
    newWindow.close(); // 关闭窗口
    handleFn&&handleFn()
  }, 100);
}